import React, { Component } from "react";
import { InputGroup, Button, Icon } from "@blueprintjs/core";
import GoogleLocation from "../../components/GoogleLocation";
import GetUserLocation from "../../components/GetUserLocation";
import LoadingIndicator from "../../components/LoadingIndicator";
import { validate } from "validate.js";
import validators from "./validators";
import { Translate, I18n } from "react-redux-i18n";
import ReactGA from "react-ga";

class MarkInterestForm extends Component {
  state = {
    register_form: {
      email: "",
      address: ""
    },
    validation_errors: {},
    show_location_loader: false,
    show_location_modal: false,
    location: {
      lat: "",
      lon: ""
    }
  };

  updateFields = (event, id) => {
    this.setState({
      register_form: {
        ...this.state.register_form,
        [event.target.id]: event.target.value
      }
    });
  };

  submitForm = e => {
    e.preventDefault();
    ReactGA.event({
      category: "B2B widget",
      action: "Clicked mark interest"
    });
    const validationErrors = validate(this.state.register_form, validators);
    this.setState({
      validation_errors: validationErrors ? validationErrors : {}
    });
    if (!validationErrors) {
      this.props.sendInterest({
        email: this.state.register_form.email,
        address: this.state.register_form.address
      });
    }
  };

  selectedLocation = location => {
    this.setState({
      show_location_modal: false,
      register_form: {
        ...this.state.register_form,
        address: location.address,
        city: location.city,
        country: location.country,
        lat: String(location.lat),
        lon: String(location.lng)
      }
    });
  };

  showLocationModal = () => {
    if (this.state.register_form.lat && this.state.register_form.lon) {
      this.setState({
        show_location_modal: true,
        location: { lat: this.state.register_form.lat, lon: this.state.register_form.lon }
      });
    } else {
      this.setState({ show_location_loader: true });
      GetUserLocation(
        position => {
          this.setState({
            show_location_modal: true,
            show_location_loader: false,
            location: { lat: position.coords.latitude, lon: position.coords.longitude }
          });
        },
        error => {
          this.setState({ show_location_modal: true, show_location_loader: false });
        }
      );
    }
  };

  render() {
    return (
      <>
        <GoogleLocation
          location={{ lat: this.state.location.lat, lng: this.state.location.lon }}
          showModal={this.state.show_location_modal}
          onClose={() => {
            this.setState({ show_location_modal: false });
          }}
          onSave={this.selectedLocation}
        />
        <form onSubmit={this.submitForm}>
          <div className={this.state.validation_errors.email ? "form-group error" : "form-group"}>
            {this.state.validation_errors.email && (
              <label htmlFor="email">
                <Translate value={this.state.validation_errors.email[0]} />
              </label>
            )}
            <InputGroup
              leftIcon="envelope"
              type="email"
              placeholder={I18n.t("sign_up.placeholders.email_address")}
              fill={true}
              id="email"
              disabled={this.props.isLoading}
              intent={this.state.validation_errors.email ? "danger" : ""}
              onChange={this.updateFields}
            />
          </div>
          <div
            className={this.state.validation_errors.address ? "form-group error" : "form-group"}
            onClick={this.showLocationModal}>
            <label htmlFor="address">
              {this.state.validation_errors.address ? (
                <Translate value={this.state.validation_errors.address[0]} />
              ) : (
                <Translate value={"user_details.labels.location"} />
              )}
            </label>
            <InputGroup
              readOnly={true}
              type="text"
              disabled={false}
              placeholder={I18n.t("user_details.placeholders.location")}
              fill={true}
              id="address"
              value={this.state.register_form.address}
              className="no-icon has-button circle-form-address"
              rightElement={
                this.state.show_location_loader ? (
                  <LoadingIndicator />
                ) : (
                  <Button className="input-button right">
                    <Icon icon="locate" iconSize="20" className="icon" />
                  </Button>
                )
              }
            />
          </div>
          <Button type="submit" style={{ display: "none" }} ref={this.props.buttonRef}></Button>
        </form>
      </>
    );
  }
}

export default MarkInterestForm;
